import React from "react"

const Icon = ({ primary = "#1A1B43", secondary = "url(#paint0_linear_1771_3121)" }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1103 3.04767C14.9385 1.56062 17.064 1.5818 17.8906 3.04865L30.8008 25.8885H30.8017L30.8721 26.0252C31.5489 27.441 30.5294 29.1307 28.9101 29.1307H3.08007C1.40865 29.1305 0.376501 27.3296 1.18944 25.8885L1.19042 25.8875L14.1103 3.04767ZM16.1484 4.03009C16.0763 3.90255 15.9122 3.92088 15.8564 4.02228L15.8506 4.03302L2.93065 26.8709L2.93163 26.8719C2.86478 26.9906 2.95183 27.1305 3.08007 27.1307H28.9101C29.0225 27.1307 29.1036 27.0232 29.0771 26.9168L29.0596 26.8719L16.1494 4.03205L16.1484 4.03009Z"
      fill={primary}
    />
    <path
      d="M17 23C17 22.4477 16.5523 22 16 22C15.4477 22 15 22.4477 15 23C15 23.5523 15.4477 24 16 24C16.5523 24 17 23.5523 17 23ZM19 23C19 24.6569 17.6569 26 16 26C14.3431 26 13 24.6569 13 23C13 21.3431 14.3431 20 16 20C17.6569 20 19 21.3431 19 23Z"
      fill={secondary}
    />
    <path
      d="M17 12C17 11.4523 16.5477 11 16 11C15.4523 11 15 11.4523 15 12V16C15 16.5477 15.4523 17 16 17C16.5477 17 17 16.5477 17 16V12ZM19 16C19 17.6523 17.6523 19 16 19C14.3477 19 13 17.6523 13 16V12C13 10.3477 14.3477 9 16 9C17.6523 9 19 10.3477 19 12V16Z"
      fill={secondary}
    />
    <defs>
      <linearGradient id="paint0_linear_1771_3121" x1="19" y1="9" x2="19" y2="26" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FD9317" />
        <stop offset="1" stopColor="#F63B3B" />
      </linearGradient>
      <linearGradient id="paint1_linear_1771_3121" x1="19" y1="9" x2="19" y2="26" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FD9317" />
        <stop offset="1" stopColor="#F63B3B" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon
